import CheckCircle from "@material-symbols/svg-500/rounded/check_circle.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const CheckCircleIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: CheckCircle });
	return <Icon />;
};

export default memo(CheckCircleIcon);
